/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * CustomModalStyles
 *
 * @file  CustomModalStyles.jsx
 * @author Gladson Samuel S
 * @since 1.0.0
 */

import { styled } from '@mui/material/styles';
import { Box, IconButton, Paper } from '@mui/material';

export const Root = styled(Box)({
  '&&': {}
});

export const PaperStyled = styled(Paper)({
  '&&': {
    padding: '24px 16px',
    margin: 0,
    boxSizing: 'border-box',
    borderRadius: 8,
    minWidth: 300,
    minHeight: 300,
    '& *': {
      boxSizing: 'border-box'
    }
  }
});

export const CloseButton = styled(IconButton)({
  '&&': {
    position: 'absolute',
    top: 8,
    right: 8,
    zIndex: 1,
    height: 24,
    width: 24,
    '& svg': {
      height: 16,
      width: 16
    }
  }
});

export const Content = styled(Box)({
  '&&': {}
});
